import { formatDateLocal } from "../../lib/script";
import SimpleCopyTextButton from "../common/SimpleCopyTextButton";
import CheckboxCell from "../common/interactive/CheckboxCell";
import { getAppointmentStatusLabel, getLocationNameFromId } from "../../lib/labels";
import { miscellaneous } from "../../lib/misc";
import RescheduledAppointments from "./RescheduledAppointments";
import classes from './Appointments.module.css'
import { useState } from "react";
import Button from "../common/Button";

export default function AppointmentsRow({data, isInTab, isRescheduled}) {
    const [showRescheduledAppointments, setShowRescheduledAppointments] = useState(false)
    return <>
        <tr className={isRescheduled ? classes.rescheduled_appointment : ''}>
            {/* if we are on tab and not on history page, remove the NG# and person name!!!  */}
            <td>
                <SimpleCopyTextButton textToCopy={data?.appointment_number} />
            </td>
            <td>{formatDateLocal(data.date)}</td>
            <td>{getLocationNameFromId(data.location_id)}</td>
            <td>{miscellaneous.convert24to12(data.begin_time)}</td>
            <td>{miscellaneous.convert24to12(data.end_time)}</td>
            <td>{data.description}</td>
            <td>{data.event?.name}</td>
            <td className="uppercase">{data.aica_dep_type}</td>
            <td className="uppercase">
                <div className={`${classes.rescheduled_appointment_cell} ${classes.appointment_type_cell}`}>
                    {getAppointmentStatusLabel(data.appointment_type)}
                    {data.rescheduled_appointments && data.rescheduled_appointments.length > 0 && <button className={`${classes.rescheduled_appointment_button} ${showRescheduledAppointments ? classes.active : ''}`} onClick={() => setShowRescheduledAppointments(prevState => prevState = !prevState)}><i className='ti ti-chevron-down'></i></button>}

                </div>
            </td>
            {/* <td>
                <CheckboxCell checked={data.is_kept} isDisabled={true} setStyle={'centered'}/>
            </td>
            <td>
                <CheckboxCell checked={data.is_missed} isDisabled={true} setStyle={'centered'}/>
            </td>
            <td>
                <CheckboxCell checked={data.is_cancelled} isDisabled={true} setStyle={'centered'}/>
            </td>
            <td className="table-cell-fit">
                <div className={classes.rescheduled_appointment_cell}>
                    <CheckboxCell checked={data.is_rescheduled} isDisabled={true} setStyle={'centered'}/>
                    {data.rescheduled_appointments && data.rescheduled_appointments.length > 0 && <button className={`${classes.rescheduled_appointment_button} ${showRescheduledAppointments ? classes.active : ''}`} onClick={() => setShowRescheduledAppointments(prevState => prevState = !prevState)}><i className='ti ti-chevron-down'></i></button>}
                </div>
            </td> */}
        </tr>
        {data.rescheduled_appointments && data.rescheduled_appointments.length > 0 && showRescheduledAppointments && <RescheduledAppointments rescheduledAppointments={data.rescheduled_appointments} />}
    </>
}